import { useState } from "react"
import { useNavigate } from "react-router-dom"
import Login from "../componentes/Login"
import Register from "../componentes/Register"
import "../Css/AuthPage.css"

export default function AuthPage() {
  const [activeTab, setActiveTab] = useState("login")
  const navigate = useNavigate()

  const handleLoginSuccess = (user) => {
    console.log("✅ Login exitoso:", user.email)
    // El componente Login ya maneja la redirección
  }

  const handleRegisterSuccess = (user) => {
    console.log("✅ Registro exitoso:", user.email)
    // Cambiar a login después del registro exitoso
    setActiveTab("login")
  }

  return (
    <div className="auth-page">
      <header className="auth-page-header">
        <div className="container">
          <div className="logo" onClick={() => navigate("/")}>
            CloudPriv
          </div>
          <button className="back-button" onClick={() => navigate("/")}>
            ← Volver al inicio
          </button>
        </div>
      </header>

      <main className="auth-page-content">
        <div className="auth-container">
          <div className="auth-card">
            {/* Tabs para alternar entre Login y Register */}
            <div className="auth-tabs">
              <button
                className={`auth-tab ${activeTab === "login" ? "active" : ""}`}
                onClick={() => setActiveTab("login")}
              >
                Iniciar Sesión
              </button>
              <button
                className={`auth-tab ${activeTab === "register" ? "active" : ""}`}
                onClick={() => setActiveTab("register")}
              >
                Registrarse
              </button>
            </div>

            {/* Contenido dinámico */}
            <div className="auth-content">
              {activeTab === "login" ? (
                <Login onLogin={handleLoginSuccess} />
              ) : (
                <Register onRegister={handleRegisterSuccess} />
              )}
            </div>
          </div>
        </div>
      </main>

      <footer className="auth-page-footer">
        <div className="container">
          <p>&copy; 2024 CloudPriv. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  )
}
